

















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./purchasing-statistics-columns";
import opsColumns from "./ops-purchasing-statistics-columns";
import clientColumns from "./client-purchasing-statistics-columns";
import AppConsts from "@/lib/appconst";
import moment from "moment";
import _ from "lodash";

class PagePurchasingStatisticsRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  warehouseCode: string;
  fromDate: Date;
  toDate: Date;
  status: string;
}
@Component
export default class PurchasingStatistics extends mixins(ListMixin, AbpBase) {
  namespace = "purchasingStatistics";
  clients = [];
  warehouses = [];
  spinShow: boolean = false;
  statuses = [];
  //filters
  pagerequest: PagePurchasingStatisticsRequest = new PagePurchasingStatisticsRequest();
  creationTime: Date[] = [];
  creationDefaultDate: Array<string> = [];
  viewDateWarning() {
    var argus = [AppConsts.reportRangeDays.range180.toString()];
    return Util.L("RangeDaysTooltip", "", ...argus);
  }
  get store() {
    return this.$store.state.purchasingStatistics;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then((result) => {
        var re = this.$store.state.client.clientsForSelect;
        this.$set(
          this.pagerequest,
          "clientCode",
          re.length === 0 ? "" : re[0].code
        );
        this.clients = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then((result) => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.$set(
          this.pagerequest,
          "warehouseCode",
          re.length === 0 ? "" : re[0].id
        );
        this.warehouses = re;
      });
  }
  async getStatuses() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getListStatusForSelect",
        data: {
          tableName: AppConsts.tableRef.tablePo.name,
          columnName: AppConsts.tableRef.tablePo.column.status,
          prefix: AppConsts.tableRef.tablePo.prefix.status,
          hasAllItem: true,
        },
      })
      .then(() => {
        var re = this.$store.state.purchaseOrder.statuses;
        this.pagerequest.status = re.length === 0 ? "" : re[0].code;
        this.statuses = re;
      });
  }
  get list() {
    var re = this.$store.state.purchasingStatistics.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  async exportToExcel() {
    this.preGetPage();
    if (
      Util.isNull(this.pagerequest.keyword) ||
      this.pagerequest.keyword === ""
    ) {
      this.pagerequest.keyword = AppConsts.allItemValue;
    }
    await this.$store.dispatch({
      type: "report/exportPurchasingStatistics",
      data: this.pagerequest,
    });
  }
  renderColumn() {
    if (this.isClient()) {
      return clientColumns.concat(columns);
    }
    if (this.isTenant()) {
      return opsColumns.concat(columns);
    }
    return opsColumns.concat(clientColumns).concat(columns);
  }
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 80,
    },
    ...this.renderColumn(),
  ];
  async created() {
    this.spinShow = true;
    try {
      await this.getClients();
      await this.getWarehouses();
      await this.getStatuses();
      this.creationTime = Util.buildDefaultViewDate(
        AppConsts.reportRangeDays.range180
      );
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
